import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const getCoins = async (page = 1, limit = 10) => {
  const params = {};
  if (page) params.page = page;
  if (limit) params.limit = limit;
  const res = await api.get(networkConfig.coins, { params });
  return res.data;
};

export const addCoin = async (formData) => {
  const res = await api.post(networkConfig.coins, formData);
  return res.data.data;
};

export const updateCoin = async (id, formData) => {
  const res = await api.put(`${networkConfig.coins}/${id}`, formData);
  return res.data.data;
};

export const toggleCoinStatus = async (id, status) => {
  const res = await api.patch(`/api/admin/coins/${id}/status`, { status });
  return res.data.data;
};

export const deleteCoin = async (id) => {
  const res = await api.delete(`${networkConfig.coins}/${id}`);
  return res.data;
};
